"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6909],{

/***/ 6909:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "YearlyContribution": function() { return /* binding */ YearlyContribution; },
  "default": function() { return /* binding */ GitHub_YearlyContribution; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./src/design-system/Box.ts
var Box = __webpack_require__(1821);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/@styled-system/space/dist/index.esm.js + 1 modules
var index_esm = __webpack_require__(4460);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(7379);
;// CONCATENATED MODULE: ./src/design-system/DevIcon.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        ";\n  display: inline-block;\n  color: ",
        ";\n  font-size: ",
        ";\n  vertical-align: middle;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var normalize = function(language) {
    var icon = language.toLowerCase();
    switch(icon){
        case "html":
            return "html5";
        case "css":
            return "css3";
        case "shell":
            return "bash";
        default:
            return icon;
    }
};
var BaseDevIcon = function(param) {
    var className = param.className, language = param.language;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
        className: "devicon-".concat(normalize(language), "-plain ").concat(className, " ").concat(language === "CSS" ? "colored" : "")
    });
};
var DevIcon = (0,styled_components_browser_esm/* default */.ZP)(BaseDevIcon).withConfig({
    componentId: "sc-dbd206fd-0"
})(_templateObject(), index_esm/* space */.Dh, function(param) {
    var color = param.color;
    return color;
}, function(param) {
    var _$fontSize = param.$fontSize, $fontSize = _$fontSize === void 0 ? "1.6rem" : _$fontSize;
    return $fontSize;
});

;// CONCATENATED MODULE: ./src/design-system/ExternalLinkIcon.tsx

function ExternalLinkIcon_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        ";\n  ",
        ";\n\n  cursor: pointer;\n  vertical-align: baseline;\n"
    ]);
    ExternalLinkIcon_templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var BaseExternalLinkIcon = function(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        className: className,
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M3 2C2.44772 2 2 2.44772 2 3V12C2 12.5523 2.44772 13 3 13H12C12.5523 13 13 12.5523 13 12V8.5C13 8.22386 12.7761 8 12.5 8C12.2239 8 12 8.22386 12 8.5V12H3V3L6.5 3C6.77614 3 7 2.77614 7 2.5C7 2.22386 6.77614 2 6.5 2H3ZM12.8536 2.14645C12.9015 2.19439 12.9377 2.24964 12.9621 2.30861C12.9861 2.36669 12.9996 2.4303 13 2.497L13 2.5V2.50049V5.5C13 5.77614 12.7761 6 12.5 6C12.2239 6 12 5.77614 12 5.5V3.70711L6.85355 8.85355C6.65829 9.04882 6.34171 9.04882 6.14645 8.85355C5.95118 8.65829 5.95118 8.34171 6.14645 8.14645L11.2929 3H9.5C9.22386 3 9 2.77614 9 2.5C9 2.22386 9.22386 2 9.5 2H12.4999H12.5C12.5678 2 12.6324 2.01349 12.6914 2.03794C12.7504 2.06234 12.8056 2.09851 12.8536 2.14645Z",
            fill: "currentColor",
            fillRule: "evenodd",
            clipRule: "evenodd"
        })
    });
};
var ExternalLinkIcon = (0,styled_components_browser_esm/* default */.ZP)(BaseExternalLinkIcon).withConfig({
    componentId: "sc-9499e1ab-0"
})(ExternalLinkIcon_templateObject(), (0,index_esm/* space */.Dh)({
    ml: 2
}), index_esm/* space */.Dh);

// EXTERNAL MODULE: ./src/design-system/Flex.ts
var Flex = __webpack_require__(2976);
;// CONCATENATED MODULE: ./src/design-system/IndicatorBar.ts

function IndicatorBar_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: 8px;\n  border-radius: 6px;\n\n  width: ",
        ";\n  background: ",
        ";\n"
    ]);
    IndicatorBar_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var IndicatorBar = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-28118539-0"
})(IndicatorBar_templateObject(), function(param) {
    var percentage = param.percentage;
    return "".concat(percentage, "%");
}, function(param) {
    var color = param.color;
    return color;
});

// EXTERNAL MODULE: ./src/design-system/Text.ts
var Text = __webpack_require__(8204);
;// CONCATENATED MODULE: ./src/design-system/OneLiner.ts

function OneLiner_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n"
    ]);
    OneLiner_templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var OneLiner = (0,styled_components_browser_esm/* default */.ZP)(Text/* Text */.x).withConfig({
    componentId: "sc-99f19d1d-0"
})(OneLiner_templateObject());

;// CONCATENATED MODULE: ./src/design-system/VisuallyHidden.ts

function VisuallyHidden_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  all: reset;\n  display: inline-block;\n  position: absolute;\n  overflow: hidden;\n  clip: rect(0 0 0 0);\n  height: 1px;\n  width: 1px;\n  margin: -1px;\n  padding: 0;\n  border: 0;\n"
    ]);
    VisuallyHidden_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var VisuallyHidden = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-da8eb044-0"
})(VisuallyHidden_templateObject());

;// CONCATENATED MODULE: ./src/components/GitHub/ContributionEntry.tsx









var RE_EMOJI = /:\+1:|:-1:|:[\w-]+:/g;
var isLanguageEdge = function(edge) {
    return Boolean(edge);
};
var ContributionEntry = function(param) {
    var repository = param.repository, index = param.index, contributions = param.contributions;
    var validLanguageEdges = repository.languages.edges.filter(isLanguageEdge);
    var padding = Array.from({
        length: 3 - validLanguageEdges.length
    }, function(_, i) {
        return i;
    });
    var repoDescription = repository.description ? repository.description.replace(RE_EMOJI, "") : "".concat(repository.name, " has no description.");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* Flex */.k, {
        as: "article",
        py: 3,
        mx: "auto",
        flexDirection: "column",
        gap: "1.5rem",
        flexWrap: "nowrap",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* Flex */.k, {
                as: "header",
                alignItems: "center",
                justifyContent: "space-between",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* Box */.x, {
                        mr: 3,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* Text */.x, {
                                as: "span",
                                $textColor: "--yellow",
                                children: [
                                    "#",
                                    index + 1
                                ]
                            }),
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                as: "span",
                                children: repository.owner.login
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* Text */.x, {
                                as: "h4",
                                $fontWeight: 300,
                                $fontSize: "2rem",
                                $display: "inline",
                                children: [
                                    "/",
                                    repository.name
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                href: repository.url,
                                target: "_blank",
                                rel: "noopener noreferrer",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(VisuallyHidden, {
                                        children: [
                                            "External link to ",
                                            repository.name,
                                            " Github repository page"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ExternalLinkIcon, {})
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* Text */.x, {
                        as: "span",
                        $fontWeight: 300,
                        $fontSize: "2rem",
                        children: [
                            "+",
                            contributions.totalCount,
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                as: "span",
                                $fontWeight: 300,
                                children: "commits"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* Box */.x, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(OneLiner, {
                    $fontWeight: 300,
                    $fontSize: "2rem",
                    title: repoDescription,
                    children: repoDescription
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* Flex */.k, {
                as: "footer",
                mt: 3,
                children: [
                    validLanguageEdges.map(function(param) {
                        var _node = param.node, color = _node.color, name = _node.name, size = param.size;
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* Flex */.k, {
                            flexDirection: "column",
                            flex: 1,
                            justifyContent: "flex-end",
                            mr: 3,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* Text */.x, {
                                    $fontWeight: 300,
                                    mb: 1,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(DevIcon, {
                                            color: color,
                                            language: name,
                                            mr: 1,
                                            $fontSize: "2rem"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            children: name
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(IndicatorBar, {
                                    color: color,
                                    percentage: 100 * size / repository.languages.totalSize
                                })
                            ]
                        }, name);
                    }),
                    padding.map(function(x) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* Flex */.k, {
                            flex: 1
                        }, x);
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/GitHub/ContributionsSummary.tsx




var ContributionsSummary = /*#__PURE__*/ (0,react.memo)(function ContributionsSummary(param) {
    var totalRepositoryContributions = param.totalRepositoryContributions, totalCommitContributions = param.totalCommitContributions, restrictedContributionsCount = param.restrictedContributionsCount, totalRepositoriesContributedTo = param.totalRepositoriesContributedTo;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* Flex */.k, {
        flexDirection: "column",
        alignItems: "stretch",
        mt: 3,
        mx: "auto",
        children: [
            {
                value: totalRepositoryContributions,
                label: "Newly created repositories",
                unit: "repos"
            },
            {
                value: totalRepositoriesContributedTo,
                label: "Repositories contributed to",
                unit: "repos"
            },
            {
                value: restrictedContributionsCount,
                label: "Private contributions",
                unit: "commits"
            },
            {
                value: totalCommitContributions,
                label: "Total contributions",
                unit: "commits"
            }, 
        ].map(function(param) {
            var value = param.value, label = param.label, unit = param.unit;
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* Flex */.k, {
                mb: 3,
                alignItems: "flex-end",
                justifyContent: "space-between",
                gap: "2rem",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* Flex */.k, {
                        flex: 1,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                            $textAlign: "start",
                            $fontWeight: 300,
                            children: label
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* Flex */.k, {
                        flex: 1,
                        flexDirection: "column",
                        alignItems: "flex-end",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                $fontWeight: 300,
                                $fontSize: "3rem",
                                children: value
                            }),
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                $fontWeight: 300,
                                children: unit
                            })
                        ]
                    })
                ]
            }, label);
        })
    });
});

// EXTERNAL MODULE: ./src/design-system/Button.tsx
var Button = __webpack_require__(2636);
// EXTERNAL MODULE: ./src/design-system/Divider.ts
var Divider = __webpack_require__(531);
// EXTERNAL MODULE: ./src/design-system/Emoji.tsx
var Emoji = __webpack_require__(2057);
;// CONCATENATED MODULE: ./src/design-system/Stale.ts

function Stale_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        ";\n  display: block;\n  width: 100%;\n  opacity: ",
        ";\n  transition: opacity 1s ease-in-out;\n"
    ]);
    Stale_templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var Stale = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-1214005e-0"
})(Stale_templateObject(), index_esm/* space */.Dh, function(param) {
    var _$stale = param.$stale, $stale = _$stale === void 0 ? false : _$stale;
    return $stale ? 0.3 : 1;
});

// EXTERNAL MODULE: ./src/functional.ts
var functional = __webpack_require__(4447);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var src_async_to_generator = __webpack_require__(7568);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(4051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__(9669);
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);
// EXTERNAL MODULE: ./node_modules/swr/dist/index.esm.js
var dist_index_esm = __webpack_require__(821);
// EXTERNAL MODULE: ./node_modules/swr/immutable/dist/index.esm.js
var immutable_dist_index_esm = __webpack_require__(154);
;// CONCATENATED MODULE: ./src/hooks/useGitHub.ts





var fetcher = function(query, variables) {
    return axios_default().post("/api/github/".concat(query), {
        variables: variables
    }).then(function(param) {
        var data = param.data;
        return data;
    });
};
var useGitHubProfile = function(param) {
    var from = param.from, to = param.to, _fallbackData = param.fallbackData, fallbackData = _fallbackData === void 0 ? null : _fallbackData;
    return useSWRImmutable("profile/".concat(from), _async_to_generator(regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    return _ctx.abrupt("return", fetcher("profile", {
                        login: "icyJoseph",
                        from: from,
                        to: to
                    }).then(function(param) {
                        var user = param.user;
                        return user;
                    }));
                case 1:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    })), {
        shouldRetryOnError: false,
        fallbackData: fallbackData
    });
};
var useGitHubContributions = function(param) {
    var from = param.from, to = param.to;
    return (0,dist_index_esm/* default */.ZP)("contributions/".concat(from, "/").concat(to), (0,src_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    return _ctx.abrupt("return", fetcher("contributions", {
                        login: "icyJoseph",
                        from: from,
                        to: to
                    }).then(function(param) {
                        var user = param.user;
                        return user.contributionsCollection;
                    }));
                case 1:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    })));
};

;// CONCATENATED MODULE: ./src/hooks/useLastNonNullableValue.ts

var useLastNonNullableValue = function(value, fallback) {
    var ref = (0,react.useRef)(value || fallback);
    (0,react.useEffect)(function() {
        if (value) {
            ref.current = value;
        }
    }, [
        value
    ]);
    return ref.current;
};

;// CONCATENATED MODULE: ./src/components/GitHub/YearlyContribution.tsx














var YearlyContribution = function(param) {
    var fallback = param.fallback, year = param.year, from = param.from, to = param.to;
    var ref = useGitHubContributions({
        from: from,
        to: to
    }), data = ref.data, error = ref.error;
    var ref1 = (0,react.useState)(0), pointer = ref1[0], setPointer = ref1[1];
    var prev = useLastNonNullableValue(data, fallback);
    var stale = prev !== fallback && !error && !data;
    (0,react.useEffect)(function() {
        if (!stale) {
            setPointer(0);
        }
    }, [
        year,
        stale
    ]);
    if (!prev) return null;
    var ref2 = data || prev, joinedGitHubContribution = ref2.joinedGitHubContribution, totalRepositoryContributions = ref2.totalRepositoryContributions, totalCommitContributions = ref2.totalCommitContributions, restrictedContributionsCount = ref2.restrictedContributionsCount, commitContributionsByRepository = ref2.commitContributionsByRepository;
    var contributionCardsLength = commitContributionsByRepository.length;
    var windowSize = Math.min(3, contributionCardsLength);
    var disabledPrev = windowSize === contributionCardsLength;
    var disabledNext = windowSize === contributionCardsLength;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* Flex */.k, {
                flexDirection: "column",
                alignItems: "center",
                my: 4,
                px: 4,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* Text */.x, {
                        as: "h3",
                        $fontSize: "2.5rem",
                        children: [
                            "Contributions in ",
                            year
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Stale, {
                        $stale: stale,
                        children: joinedGitHubContribution ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* Flex */.k, {
                            mt: 3,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* Text */.x, {
                                $fontSize: "2rem",
                                $fontWeight: 300,
                                children: [
                                    "Joined GitHub",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Emoji/* Emoji */.d, {
                                        symbol: "\uD83C\uDF89",
                                        title: "Joined Github",
                                        ariaLabel: "Celebration",
                                        mx: 2
                                    })
                                ]
                            })
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ContributionsSummary, {
                            totalRepositoryContributions: totalRepositoryContributions,
                            totalCommitContributions: totalCommitContributions,
                            restrictedContributionsCount: restrictedContributionsCount,
                            totalRepositoriesContributedTo: commitContributionsByRepository.length
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stale, {
                my: 4,
                $stale: stale,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* Text */.x, {
                        as: "h3",
                        $fontSize: "2.5rem",
                        children: [
                            "Repositories in ",
                            year
                        ]
                    }),
                    (0,functional/* circularSlice */.XT)(commitContributionsByRepository, pointer, pointer + windowSize).map(function(param, index) {
                        var contributions = param.contributions, repository = param.repository;
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ContributionEntry, {
                                    index: (pointer + index) % contributionCardsLength,
                                    repository: repository,
                                    contributions: contributions
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider/* Divider */.i, {})
                            ]
                        }, repository.id);
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* Box */.x, {
                mt: 3,
                $width: "100%",
                $display: "flex",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                        type: "button",
                        onClick: function() {
                            if (disabledPrev) return;
                            setPointer(function(index) {
                                return (0,functional/* circular */.iu)(index, -windowSize, commitContributionsByRepository.length);
                            });
                        },
                        disabled: disabledPrev,
                        my: 2,
                        mx: "auto",
                        children: "Prev"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                        type: "button",
                        onClick: function() {
                            if (disabledNext) return;
                            setPointer(function(index) {
                                return (0,functional/* circular */.iu)(index, windowSize, commitContributionsByRepository.length);
                            });
                        },
                        disabled: disabledNext,
                        my: 2,
                        mx: "auto",
                        children: "Next"
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var GitHub_YearlyContribution = (YearlyContribution);


/***/ }),

/***/ 154:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ index; }
/* harmony export */ });
/* unused harmony export immutable */
/* harmony import */ var swr__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(821);


/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

var isFunction = function (v) { return typeof v == 'function'; };

var normalize = function (args) {
    return isFunction(args[1])
        ? [args[0], args[1], args[2] || {}]
        : [args[0], null, (args[1] === null ? args[2] : args[1]) || {}];
};

// Create a custom hook with a middleware
var withMiddleware = function (useSWR, middleware) {
    return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var _a = normalize(args), key = _a[0], fn = _a[1], config = _a[2];
        var middlewares = (config.use || []).concat(middleware);
        return useSWR(key, fn, __assign(__assign({}, config), { use: middlewares }));
    };
};

var immutable = function (useSWRNext) { return function (key, fetcher, config) {
    // Always override all revalidate options.
    config.revalidateOnFocus = false;
    config.revalidateIfStale = false;
    config.revalidateOnReconnect = false;
    return useSWRNext(key, fetcher, config);
}; };
var index = withMiddleware(swr__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP, immutable);




/***/ })

}]);